import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/paypal.png'


const _hoisted_1 = {
  id: "donations-content",
  class: "card content-card"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "thanks" }, " Hvala na donaciji! Vaša donacija pojavit će se ispod uskoro. ", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "two-boxes" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "box donationBox",
    style: {"order":"1"}
  }, [
    /*#__PURE__*/_createVNode("div", { class: "boxTitle" }, "Kava za programera ☕"),
    /*#__PURE__*/_createVNode("div", { style: {"margin-top":"15px"} }, [
      /*#__PURE__*/_createVNode("div", { class: "amount quantity" }, [
        /*#__PURE__*/_createTextVNode(" Ukupno: "),
        /*#__PURE__*/_createVNode("div", { id: "totalContainer" }, [
          /*#__PURE__*/_createVNode("span", { id: "total" }, "10"),
          /*#__PURE__*/_createVNode("span", null, "kn")
        ])
      ]),
      /*#__PURE__*/_createVNode("div", { class: "amount total" }, [
        /*#__PURE__*/_createVNode("span", { class: "stepUp" }, "➕"),
        /*#__PURE__*/_createVNode("span", { class: "stepDown" }, "➖"),
        /*#__PURE__*/_createVNode("div", {
          id: "amount",
          contenteditable: "true"
        }, "1")
      ])
    ]),
    /*#__PURE__*/_createVNode("textarea", {
      id: "comment",
      rows: "5",
      placeholder: "Vaša poruka... (nije obavezno)"
    }),
    /*#__PURE__*/_createVNode("textarea", {
      id: "username",
      rows: "1",
      placeholder: "Ime (nije obavezno)"
    }),
    /*#__PURE__*/_createVNode("div", { class: "donate" }, [
      /*#__PURE__*/_createTextVNode(" DONIRAJ "),
      /*#__PURE__*/_createVNode("div", { class: "paymentMethod" }, [
        /*#__PURE__*/_createVNode("div", {
          id: "donate",
          style: {"margin-top":"10px"}
        }, [
          /*#__PURE__*/_createVNode("img", {
            src: _imports_0,
            alt: "Paypal",
            title: "PayPal"
          })
        ]),
        /*#__PURE__*/_createVNode("div", { id: "iban" }, "Kopiraj IBAN")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "box whyDonate" }, [
    /*#__PURE__*/_createVNode("div", { class: "boxTitle" }, "Zašto donirati?"),
    /*#__PURE__*/_createVNode("div", null, [
      /*#__PURE__*/_createTextVNode(" Donacijom omogućujete održavanje"),
      /*#__PURE__*/_createVNode("sup", null, [
        /*#__PURE__*/_createTextVNode("? "),
        /*#__PURE__*/_createVNode("div", { class: "moreSup" }, "dev-fee + hosting + domena")
      ]),
      /*#__PURE__*/_createTextVNode("i nastavak razvoja proširenja. ")
    ]),
    /*#__PURE__*/_createVNode("div", null, " Ako sam vam uštedio vrijeme, olakšao školovanje ili pomogao u nevolji, možda ste poželjeli počastiti me kavom :) "),
    /*#__PURE__*/_createVNode("div", null, " Donacije su jedini izvor prihoda za nastavak rada. Hvala vam na korištenju proširenja i donaciji! "),
    /*#__PURE__*/_createVNode("div", { style: {"font-style":"italic","font-size":"12px","text-align":"left"} }, " Kristijan Rosandić, 4. razred ETŠ Zagreb ")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "box donations" }, [
  /*#__PURE__*/_createVNode("div", { class: "boxTitle" }, "Donacije")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}